
import React, { useState } from 'react'
import { styled } from "@mui/material/styles";
import { Container, Box, Paper, Typography, Table, TableBody, TableCell, TableRow, Card, CardContent, Link, Divider, Grid, Button } from "@mui/material";
import { Form, Formik } from 'formik';
import CustomInputLogin from '../../../../Components/CustomInputLogin/CustomInputLogin';
import CustomDropdownMui from '../../../../Components/CustomDropDown/CustomDropdown';
import CustomFromAndToDate from '../../../../Components/CustomFromAndToDate/CustomFromAndToDate';
import * as Yup from 'yup';
import actions from '../../../../ReduxStore/actions';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';


const ProfileContainer = styled(Box)(({ theme }) => ({
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    padding: theme.spacing(2),
}));


const ResponsiveBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
    },
}));

const PostInternship = ({ handleAddFormGoBackButton }) => {
    const [uploadedFile, setUploadedFile] = useState(null);


    const placeOfInterviewOptions = [
        { value: "Not applicable", label: "Not Applicable" },
        { value: "Bengaluru", label: "BENGALURU" },
        { value: "Bhopal", label: "BHOPAL" },
        { value: "Bhubaneswar", label: "BHUBANESWAR" },
        { value: "Chennai", label: "CHENNAI" },
        { value: "Gandhinagar", label: "GANDHINAGAR" },
        { value: "Hyderabad", label: "HYDERABAD" },
        { value: "Jodhpur", label: "JODHPUR" },
        { value: "Kangra", label: "KANGRA" },
        { value: "Kannur", label: "KANNUR" },
        { value: "Kolkata", label: "KOLKATA" },
        { value: "Mumbai", label: "MUMBAI" },
        { value: "New Delhi", label: "NEW DELHI" },
        { value: "Patna", label: "PATNA" },
        { value: "Raebareli", label: "RAEBARELI" },
        { value: "Shillong", label: "SHILLONG" },
    ];
    const offeredToOptions = [
        { value: "", label: "-select-" },
        { value: "All UG", label: "ALL UG" },
        { value: "All PG", label: "ALL PG" },
        { value: "Any", label: "ANY" },
        { value: "Fashion Management", label: "Fashion Management" },
        { value: "Fashion Technology Master", label: "Fashion Technology Master" },
        { value: "Master Design Space", label: "Master of Design Space" },
        { value: "Accessory Design", label: "Accessory Design" },
        { value: "Fashion Communication", label: "Fashion Communication" },
        { value: "Fashion Design", label: "Fashion Design" },
        { value: "Fashion Technology", label: "Fashion Technology" },
        { value: "Knitwear Design", label: "Knitwear Design" },
        { value: "Leather Design", label: "Leather Design" },
        { value: "Textile Design", label: "Textile Design" },
    ];


    const jobType = [
        { value: "Internship", label: "Internship" },
        { value: "graduationProject", label: "Graduation Project" },
    ];
    const dispatch = useDispatch()

    const { EventPost } = useSelector(
        (state) => state?.EventPost
    );
    const [loading, setLoading] = useState(false);


    const sessionUserId = sessionStorage.getItem("userId")

    const handleSubmit = async (values, { resetForm }) => {
        console.log("Form Values of contact form:", values);
        setLoading(true)
        const formData = new FormData();
        // formData.append("event_startdate", values?.fromDate);
        // formData.append("event_enddate", values?.toDate);
        // formData.append("campusname", values?.CampusName);
        // formData.append("eventtitle", values?.EventTitle);
        // formData.append("eventdetails", values?.details);


        const data1 = {
            data: {
                user_id: sessionUserId,
                company_name: values?.companyName,
                company_address: values?.address,
                company_city: values?.city,
                offered_to: values?.offeredto,
                // skills: values?.skills,
                place_of_interview: values?.place_of_interview,
                // internship_graduation_project: values?.inernship_graduation_project,
                internship_location: values?.location,
                total_vacancies: values?.vacancies,
                stipend_per_month: values?.stipend,
                starting_date: values?.fromDate,
                closing_date: values?.toDate,

                mobile_no: values?.mobile_number,
                contact_person: values?.contactPerson,
                url: values?.url,
                description: values?.description,

                // companyName: "",
                // address: "",
                // city: "",
                // offeredto: "",
                // place_of_interview: "",
                // inernship_graduation_project: "",
                // location: "",
                // vacancies: "",
                // stipend: "",
                // contactPerson: "",
                // mobile_number: "",
                // url: "",
                // description: "",



            },
            method: "post",
            apiName: `createInternshipPost`,
            // isFormData: true,
        };

        const responseData = await dispatch(actions.ADDPOSTINTERNSHIP(data1));
        console.log(responseData, "responseDataresponseData")
        if (responseData?.payload?.message === "Internship posted successfully") {
            setLoading(false)
            // toast.success(`Event ${editById ? "updated" : "created"} successfully`);
            toast.success(`Internship posted successfully.`);

            resetForm();
            setUploadedFile([]); // Clear uploaded files
            setTimeout(() => {

                handleAddFormGoBackButton();

            }, 1500);


        } else {
            setLoading(false)

            toast.error(responseData?.payload?.message)

        }
    };
    const validationSchema = Yup.object().shape({
        companyName: Yup.string().required('Company Name is required'),
        address: Yup.string().required('Address is required'),
        city: Yup.string().required('City is required'),
        offeredto: Yup.string().required('Offered to is required'),
        place_of_interview: Yup.string().required('Place of Interview is required'),
        // inernship_graduatio/n_project: Yup.string().required('Internship / Graduation Project is required'),
        location: Yup.string().required('Location is required'),
        vacancies: Yup.number()
            .typeError('Must be a number')
            .required('Total number of Vacancies is required'),
        stipend: Yup.number()
            .typeError('Must be a number')
            .required('Stipend is required'),
        contactPerson: Yup.string().required('Contact Person is required'),
        mobile_number: Yup.string()
            .matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits')
            .required('Mobile number is required'),
        url: Yup.string().url('Invalid URL'),
        description: Yup.string().required('Description is required'),
    });




    return (
        <Box>
            <Box data-aos="zoom-in" data-aos-duration="1000"
                sx={{
                    position: 'relative',
                }}
            >
                <Box>
                    <ProfileContainer p={{ xs: 0 }} mb={2} >
                        <Container maxWidth="lg" >
                            <ResponsiveBox mt={2}>
                                <Paper elevation={3} sx={{ p: 3, flex: 1 }}>
                                    <Typography variant="h6" gutterBottom>Internship or Graduation Project Details</Typography>
                                    <Divider />
                                    <Box>
                                        <Formik
                                            initialValues={{
                                                companyName: "",
                                                address: "",
                                                city: "",
                                                offeredto: "",
                                                place_of_interview: "",
                                                // inernship_graduation_project: "",
                                                location: "",
                                                fromDate: "",
                                                toDate: "",
                                                vacancies: "",
                                                stipend: "",
                                                contactPerson: "",
                                                mobile_number: "",
                                                url: "",
                                                description: "",
                                            }}

                                            validationSchema={validationSchema}
                                            onSubmit={handleSubmit}
                                        >
                                            {({ isSubmitting, values, setFieldValue, resetForm, errors, touched, handleChange, handleBlur }) => (
                                                <Form>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 2,
                                                            mt: 2
                                                        }}
                                                    >


                                                        <Grid container spacing={2}>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Name of the Company"
                                                                    name="companyName"
                                                                    custPlaceholder="Enter Name of the Company"
                                                                    inputType="input"
                                                                // image={email_input_icon}
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Address of the Company"
                                                                    name="address"
                                                                    custPlaceholder="Enter Address of the Company"
                                                                    inputType="input"
                                                                // image={email_input_icon}
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="City of the Company"
                                                                    name="city"
                                                                    custPlaceholder="Enter Address of the Company"
                                                                    inputType="input"
                                                                // image={email_input_icon}
                                                                />
                                                            </Grid>
                                                            <Grid item size={{ md: 4, xs: 12, sm: 6 }} >
                                                                <CustomDropdownMui
                                                                    label="Offered to"
                                                                    name="offeredto"
                                                                    options={offeredToOptions}
                                                                    custPlaceholder="Select Offered To"
                                                                // image={country_icon}
                                                                // important={true}
                                                                />
                                                            </Grid>

                                                            <Grid item size={{ md: 4, xs: 12, sm: 6 }} >
                                                                <CustomDropdownMui
                                                                    label="Place of Interview (Incase)"
                                                                    name="place_of_interview"
                                                                    options={placeOfInterviewOptions}
                                                                    custPlaceholder="Select Place of Interview (Incase)"
                                                                // image={country_icon}
                                                                // important={true}
                                                                />
                                                            </Grid>
                                                            <Grid item size={{ md: 4, xs: 12, sm: 6 }} >
                                                                <CustomDropdownMui
                                                                    label="Internship / Graduation Project"
                                                                    name="inernship_graduation_project"
                                                                    options={jobType}
                                                                    custPlaceholder="Select Internship / Graduation Project"
                                                                // image={country_icon}
                                                                // important={true}
                                                                />
                                                            </Grid>

                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Location of Internship / Graduation Project"
                                                                    name="location"
                                                                    custPlaceholder="Enter Location of Internship / Graduation Project"
                                                                    inputType="input"
                                                                // image={email_input_icon}
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Total number of Vacancies"
                                                                    name="vacancies"
                                                                    custPlaceholder="Enter Total number of Vacancies"
                                                                    inputType="number"
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Stipend Per Month in Rupees"
                                                                    name="stipend"
                                                                    custPlaceholder="Enter Stipend Per Month in Rupees"
                                                                    inputType="input"
                                                                />
                                                            </Grid>



                                                            {/* <Grid size={{md:4}}> */}
                                                            <CustomFromAndToDate label1="Starting Date" label2="Closing Date" />
                                                            {/* </Grid> */}
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Contact Person"
                                                                    name="contactPerson"
                                                                    custPlaceholder="Enter Contact Person"
                                                                    inputType="input"
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="Mobile No"
                                                                    name="mobile_number"
                                                                    custPlaceholder="Enter Mobile Number"
                                                                    inputType="Number"
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 12, sm: 6 }}>
                                                                <CustomInputLogin
                                                                    label="URL"
                                                                    name="url"
                                                                    custPlaceholder="Enter URL"
                                                                    inputType="input"
                                                                />
                                                            </Grid>



                                                            <Grid size={{ md: 12, xs: 12, sm: 12 }}>
                                                                <CustomInputLogin
                                                                    label="Description"
                                                                    name="description"
                                                                    custPlaceholder="Description"
                                                                    inputType="textarea"
                                                                />
                                                            </Grid>


                                                            <Grid size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "end" }}>
                                                                <Button
                                                                    onClick={() => {
                                                                        // resetForm()
                                                                        handleAddFormGoBackButton()
                                                                    }}
                                                                    variant="contained"
                                                                    sx={{
                                                                        textTransform: "none",
                                                                        color: "black",
                                                                        fontSize: "16px",
                                                                        padding: { xs: "0px 20px", md: "0px 50px" },
                                                                        marginRight: "5px",
                                                                        boxShadow: 1,
                                                                        border: "1px solid #ced4da",
                                                                        minHeight: "40px",
                                                                        // borderRadius: "23px",
                                                                        background: "white 0% 0% no-repeat padding-box",
                                                                        "&:hover": {
                                                                            backgroundColor: "white",
                                                                        },
                                                                    }}
                                                                >
                                                                    Go back
                                                                </Button>
                                                                <Button
                                                                    type="submit"
                                                                    variant="contained"
                                                                    sx={{
                                                                        textTransform: "none",
                                                                        color: "white",
                                                                        fontSize: "16px",
                                                                        padding: { xs: "0px 20px", md: "0px 50px" },

                                                                        boxShadow: "none",
                                                                        minHeight: "40px",
                                                                        // borderRadius: "23px",
                                                                        background: "var(--main-color) 0% 0% no-repeat padding-box",
                                                                        "&:hover": {
                                                                            backgroundColor: "var(--main-color)",
                                                                        },
                                                                    }}
                                                                >
                                                                    Submit
                                                                </Button>
                                                            </Grid>

                                                        </Grid>




                                                    </Box>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Box>
                                </Paper>
                            </ResponsiveBox>
                        </Container>
                    </ProfileContainer>
                </Box>
            </Box>
            <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />

        </Box>
    )
}

export default PostInternship